
import { TranslationSet } from '../types';

export const family: TranslationSet = {
  'family.information': {
    en: 'Family Information',
    ja: '家族情報',
    es: 'Información familiar',
    zh: '家庭信息',
    fa: 'اطلاعات خانواده'
  },
  'family.parents': {
    en: 'Parents',
    ja: '両親',
    es: 'Padres',
    zh: '父母',
    fa: 'والدین'
  },
  'family.siblings': {
    en: 'Siblings',
    ja: '兄弟姉妹',
    es: 'Hermanos y hermanas',
    zh: '兄弟姐妹',
    fa: 'خواهر و برادر'
  },
  'family.grandparents': {
    en: 'Grandparents',
    ja: '祖父母',
    es: 'Abuelos',
    zh: '祖父母',
    fa: 'پدربزرگ و مادربزرگ'
  },
  'family.maternal': {
    en: 'Maternal',
    ja: '母方',
    es: 'Maternos',
    zh: '外祖父母',
    fa: 'مادری'
  },
  'family.paternal': {
    en: 'Paternal',
    ja: '父方',
    es: 'Paternos',
    zh: '祖父母',
    fa: 'پدری'
  },
  'family.grandparentRelation': {
    en: 'Relationship',
    ja: '関係',
    es: 'Relación',
    zh: '关系',
    fa: 'نسبت'
  }
};
